<template>
  <div class="custom-input traveller-autocomplete select">
    <fa v-if="faClass" :fa-class="faClass" class="vh-align" />

    <div class="traveller-autocomplete__select">
      <div v-if="label" :class="getLabelClass">
        {{ $t(label) }}
      </div>

      <multiselect
        :placeholder="$t(placeholder)"
        name="traveller"
        ref="traveller"
        v-model="search"
        :options="travellerItems"
        :multiple="false"
        :searchable="true"
        :loading="isFetching"
        :internal-search="false"
        :close-on-select="true"
        :show-no-results="true"
        open-direction="bottom"
        :custom-label="customLabel"
        :preserve-search="true"
        select-label=""
        :deselect-label="$t('_deselect')"
        selected-label=""
        @search-change="onChangeTraveller"
        class="formElement-blue"
        :clear-on-select="false"
        @close="onClose"
      >
        <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <div class="option__title">
              <traveller :contact="props.option" />
            </div>
          </span>
        </template>

        <template slot="clear" slot-scope="props">
          <div
            class="multiselect__clear"
            v-if="value || search"
            @mousedown.prevent.stop="removeTraveller()"
          >
            <span :id="tooltipMinusId">&times;</span>

            <b-tooltip :target="tooltipMinusId">
              {{ $t("_deselect") }}
            </b-tooltip>
          </div>
        </template>

        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">
              {{ fullName(props.option, false) }}
            </span>
          </div>
        </template>

        <template slot="noOptions">
          {{ $t("traveller.find") }}
        </template>

        <template slot="noResult">
          {{ $t("traveller.no_result") }}
        </template>
      </multiselect>
    </div>

    <div class="travellers-controller" v-if="!search">
      <add
        :id="tooltipAddId"
        class="add-btn"
        :text="$t('_traveller_add')"
        :btnDefault="false"
        :index="index"
        :company-input-fields="companyInputFields"
        :unlogged-infos="unloggedInfos"
        @input="addTraveller"
      />
    </div>
  </div>
</template>

<script>
import { cancelAxiosRequest } from "@/utils/apiUtils";
import selectInput from "@/components/frontoffice/form/baseInput/select";
import CommonApi from "@/api/commonApi";
import fa from "@/components/global/icon/fontAwesome";
import formMethods from "@/components/frontoffice/mixins/formMethods";
import formatter from "@/components/global/mixins/formatterMethods";
import traveller from "@/components/frontoffice/form/traveller/show";
import add from "@/components/frontoffice/form/traveller/add";

export default {
  components: {
    fa,
    selectInput,
    traveller,
    add,
  },

  mixins: [formMethods, formatter],

  props: {
    index: {
      type: String,
      required: true,
    },
    value: {
      type: [Object, Number, String],
    },
    label: String,
    placeholder: {
      type: String,
      default: "",
    },
    faClass: String,
    required: {
      type: Boolean,
      default: true,
    },
    alreadyDisplayedTravellers: {
      type: Array,
      required: true,
    },
    rank: {
      type: Number,
      required: true,
      validator(value) {
        return [1, 2].indexOf(value) !== -1;
      },
    },
    isUnlogged: {
      type: Boolean,
      default: false,
    },
    unloggedInfos: Object,
  },

  data() {
    return {
      commonApi: new CommonApi(),
      travellerItems: [],
      isFetching: false,
      search: this.value,
    };
  },

  inject: ["mustLoad", "bedrooms"],

  mounted() {
    if (!this.value && this.mustLoad) {
      let index = this.index.split("-");
      let type = index[0];
      let room = index[1] - 1;
      let traveller = index[2];

      this.search = this.bedrooms[type].travellers[room][traveller];
    }
  },

  methods: {
    addTraveller(traveller) {
      this.search = {
        email: traveller.email,
        enabled: true,
        first_name: traveller.firstName,
        gender: traveller.gender,
        id: traveller.id,
        last_name: traveller.lastName,
        mobile_phone: traveller.mobilePhone,
        traveller_input_fields: traveller.inputFields,
      };
    },

    removeTraveller() {
      this.search = null;
    },

    customLabel({ travellerName }) {
      return `${travellerName}`;
    },

    onChangeTraveller(search) {
      // si requetes déjà en cours, on annule
      cancelAxiosRequest();
      // mini 3 caractères
      if (search.length < 3) {
        this.travellerItems = [];
        return;
      }

      // Get travellers
      this.isFetching = true;

      let uniqueChain = this.unloggedInfos
        ? this.unloggedInfos.companyUniqueChain
        : null;

      this.commonApi
        .searchTraveller(search, 100, uniqueChain)
        .then((response) => {
          // let searchableTravellers = null
          this.travellerItems = [];

          for (let i in response.data.data) {
            if (response.data.data.hasOwnProperty(i)) {
              let traveller = response.data.data[i].traveller;

              if (
                !this.alreadyDisplayedTravellers.some(function (
                  searchableTraveller
                ) {
                  return searchableTraveller.id === traveller.id;
                })
              ) {
                this.travellerItems.push(traveller);
              }
            }
          }
          this.isFetching = false;
        })
        .catch(function (error) {
          // errors already catched by axios interceptor => @/views/frontoffice/home.vue
        });
    },

    onClose() {
      if (!this.search) {
        this.$refs.traveller.search = "";
      }
    },
  },

  computed: {
    tooltipMinusId() {
      return "tooltip-" + this.index + "-minus";
    },

    tooltipAddId() {
      return "tooltip-" + this.index + "-add";
    },

    companyInputFields() {
      let ret = null;

      if (this.unloggedInfos) ret = this.unloggedInfos.companyInputFields;

      return ret;
    },
  },

  watch: {
    search(newVal, oldVal) {
      this.$emit("change", {
        new: newVal,
        old: oldVal,
        rank: this.rank,
      });
    },
  },
};
</script>
